export default __webpack_public_path__ + "static/media/features-thumb.eda2a484.png";